export default {
    siteKey: '6LcmMmofAAAAAM3yXL2c_ZJOwocbBe7q1UNAUzSv'
}
